import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export class BasicView {
  constructor(containerId, sharedScene, appState) {
    this.container = document.getElementById(containerId);
    this.sharedScene = sharedScene;
    this.appState = appState;

    this.renderer = null;
    this.camera = null;
    this.controls = null;
    this.isInitialized = false;
    this.isActive = false;
    this.animationFrameId = null;
  }

  /**
   * Set up standard WebGLRenderer, OrbitControls, and PerspectiveCamera
   */
  init() {
    if (this.isInitialized) return;

    const width = window.innerWidth;
    const height = window.innerHeight;

    // Set up camera (Z-Up coordinate alignment inherits from THREE.Object3D.DEFAULT_UP)
    this.camera = new THREE.PerspectiveCamera(45, width / height, 1, 5000);
    this.camera.position.set(0, -400, 200);

    // Renderer
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(width, height);
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

    // Clear any loading text inside container
    this.container.innerHTML = '';
    this.container.appendChild(this.renderer.domElement);

    // OrbitControls
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.target.set(0, 0, 0);
    this.controls.maxPolarAngle = Math.PI / 2 - 0.05; // Prevent user from looking underneath the stadium plane

    // Resize event
    window.addEventListener('resize', this._onResize.bind(this));

    this.isInitialized = true;
  }

  _onResize() {
    if (!this.isInitialized || !this.isActive) return;

    const width = window.innerWidth;
    const height = window.innerHeight;

    this.camera.aspect = width / height;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(width, height);
  }

  show() {
    this.isActive = true;
    this.container.style.display = 'block';

    // Prepare ground plane for solid green viewing
    this.sharedScene.setMode('basic');

    // Sync size on show
    this._onResize();

    // Start rendering
    this._animate();
  }

  hide() {
    this.isActive = false;
    this.container.style.display = 'none';

    // Stop rendering loop to conserve CPU/GPU
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  _animate() {
    if (!this.isActive) return;

    this.animationFrameId = requestAnimationFrame(this._animate.bind(this));

    this.controls.update();
    this.renderer.render(this.sharedScene.scene, this.camera);
  }
}
